import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconVideo2"><Path d="M16.75 4.5C17.1642 4.5 17.5 4.83579 17.5 5.25V18.75C17.5 19.1642 17.1642 19.5 16.75 19.5H2.75C2.33579 19.5 2 19.1642 2 18.75V5.25C2 4.83579 2.33579 4.5 2.75 4.5H16.75Z" fill="currentColor"/><Path d="M21.4717 6.80371C21.7027 6.71136 21.9649 6.73942 22.1709 6.87891C22.3768 7.01845 22.5 7.25124 22.5 7.5V16.5C22.5 16.7488 22.3768 16.9816 22.1709 17.1211C21.9649 17.2606 21.7027 17.2886 21.4717 17.1963L18.5 16.0078V7.99219L21.4717 6.80371Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideo2;
